module.exports = __webpack_public_path__ + "static/media/add-message.e5b96aad.svg";